import React from "react";
import { Button, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";

/**
 * Modal listing search-data competitor suggestions with Track actions.
 */
export default function CompetitorSuggestionsModal({
	isOpen,
	onClose,
	loading = false,
	suggestions = [],
	busyKey = null,
	onTrack,
}) {
	function handleClose() {
		if (busyKey) return;
		onClose?.();
	}

	function rowKey(s, index) {
		return s.domain || s.url || s.website || s.name || String(index);
	}

	return (
		<Modal
			isOpen={isOpen}
			toggle={handleClose}
			centered
			size="lg"
			className="monitoring__add-modal monitoring__suggest-modal"
			backdrop={busyKey ? "static" : true}
			keyboard={!busyKey}
		>
			<ModalHeader toggle={busyKey ? undefined : handleClose}>
				Recommended competitors
			</ModalHeader>
			<ModalBody>
				<p className="monitoring__suggest-modal-sub text-muted mb-3">
					From search data, ranked by keyword-overlap relevance.{" "}
					<span className="monitoring__suggest-ai-badge monitoring__suggest-ai-badge--inline">
						✓ also named by AI
					</span>{" "}
					means the same competitor was independently surfaced in AI answers — a
					stronger signal.
				</p>

				{loading ? (
					<div className="monitoring__suggest-modal-status text-muted">
						<Spinner size="sm" className="me-2" />
						Fetching competitors from search data…
					</div>
				) : !suggestions.length ? (
					<div className="monitoring__suggest-modal-status text-muted">
						No vendor suggestions available.
					</div>
				) : (
					<div className="monitoring__suggest-modal-table-wrap">
						<table className="monitoring__table monitoring__suggest-modal-table">
							<thead>
								<tr>
									<th scope="col">Competitor</th>
									<th scope="col" className="monitoring__th-num">
										Relevance
									</th>
									<th scope="col" className="monitoring__th-num">
										Shared KW
									</th>
									<th scope="col" className="monitoring__th-num">
										Action
									</th>
								</tr>
							</thead>
							<tbody>
								{suggestions.map((s, index) => {
									const key = rowKey(s, index);
									const isBusy = busyKey === key;
									// Strict: only true/"true"/1 count as tracked so API false/"false" stays Trackable
									const tracked =
										s.tracked === true ||
										s.tracked === 1 ||
										s.tracked === "true" ||
										s.tracked === "1";
									const displayDomain = (
										s.domain ||
										s.url ||
										s.website ||
										""
									)
										.replace(/^https?:\/\//i, "")
										.replace(/\/.*$/, "");
									const displayName = s.name || displayDomain || "—";
									return (
										<tr key={key}>
											<td>
												<div className="monitoring__suggest-comp">
													<span className="monitoring__suggest-comp-name">
														{displayName}
													</span>
													{s.in_ai ? (
														<span className="monitoring__suggest-ai-badge">
															✓ also named by AI
														</span>
													) : null}
												</div>
												{displayDomain ? (
													<div className="monitoring__suggest-comp-domain text-muted">
														{displayDomain}
													</div>
												) : null}
											</td>
											<td className="monitoring__td-num">
												{s.relevance != null ? s.relevance : "—"}
											</td>
											<td className="monitoring__td-num">
												{s.common_keywords != null ? s.common_keywords : "—"}
											</td>
											<td className="monitoring__td-num">
												{tracked ? (
													<Button
														size="sm"
														color="secondary"
														outline
														disabled
														className="monitoring__suggest-track-btn"
													>
														Tracking
													</Button>
												) : (
													<Button
														size="sm"
														color="primary"
														className="monitoring__action-btn monitoring__action-btn--primary monitoring__suggest-track-btn"
														disabled={Boolean(busyKey)}
														onClick={() => onTrack?.(s)}
													>
														{isBusy ? (
															<>
																<Spinner size="sm" className="me-1" />
																Tracking…
															</>
														) : (
															"+ Track"
														)}
													</Button>
												)}
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
				)}
			</ModalBody>
		</Modal>
	);
}
